// extracted by mini-css-extract-plugin
module.exports = {"root":"onAu_root__JvY9N","img":"onAu_img__yVk79"};